import React, { useEffect, useRef, useState } from 'react'
import invoice from '../../images/invoice 1.png'
import add from '../../images/addition 2.png'
import toast from 'react-hot-toast';
import HttpClient from '../../utils/HttpClient';
import './InvoiceCreation.css';
import Loader from '../../Loader/Loader';
import InvoiceForm2 from '../invoice/invoiceForm2/InvoiceForm2';
import { useDispatch } from 'react-redux';
import { add_logo_url } from '../../redux/reducers/invoiceSlice';
import { useSelector } from 'react-redux';
import { useUserData } from '../../Providers/UserWrapper';

const InvoiceCreation = () => {
    const { setIsLoading } = useUserData();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        logoUrl: "",
        dateIssue: "",
        dateDue: "",
        clientName: "",
        taskList: [{ taskDescription: "", rate: 0 }], // Initialize with one empty task
        total: 0,
    });

    const {
        customerName,
        customerRFCID,
        state,
        city,
        zip,
        emailRecipents,
        invoiceDate,
        invoice,
        Oredr,
        reference,
        purchaseOrder,
        invoiceDetailsType,
        salesTaxPercentage,
        salesTaxAmount,
        other,
        total,
        subTotal,
    } = useSelector(state => state?.invoices);

    const [invoiceRes, setInvoiceRes] = useState(null);
    const [imageUploadeLoader, setImageUploadLoader] = useState(false);
    const [invoiceLoader, setInvoiceLoader] = useState(false);

    const fileInputRef = useRef(null);

    // console.log('invoiceRes: ', invoiceRes);


    // Calculate total whenever taskList changes
    useEffect(() => {
        const calculatedTotal = formData.taskList.reduce((sum, task) => sum + (parseInt(task.rate) || 0), 0);
        setFormData(prev => ({
            ...prev,
            total: calculatedTotal
        }));
    }, [formData.taskList]);




    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleTaskChange = (index, field, value) => {
        const updatedTasks = [...formData.taskList];
        updatedTasks[index][field] = value;
        setFormData(prev => ({
            ...prev,
            taskList: updatedTasks,
        }));
    };

    const addNewTask = () => {
        setFormData(prev => ({
            ...prev,
            taskList: [...prev.taskList, { taskDescription: "", rate: 0 }]
        }));
    };

    const removeTask = (index) => {
        if (formData.taskList.length <= 1) {
            toast.error("At least one task is required");
            return;
        }
        const updatedTasks = formData.taskList.filter((_, i) => i !== index);
        setFormData(prev => ({
            ...prev,
            taskList: updatedTasks,
        }));
    };

    const fetchUserExistedLogo = async () => {
        try {
            setIsLoading(true);
            const res = await HttpClient.requestData("user-setting", "GET");
            if (res && res?.success) {
                setFormData(prev => ({
                    ...prev,
                    logoUrl: res?.data?.logo || "",
                }));
            } else {
                toast.error(res?.message || "something went wrong!!!");
                setFormData(prev => ({
                    ...prev,
                    logoUrl: "",
                }));
            }
        } catch (error) {
            toast.error(error?.message || "something went wrong!!!");
            setFormData(prev => ({
                ...prev,
                logoUrl: "",
            }));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUserExistedLogo();
    }, []);

    const handleLogoUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImageUploadLoader(true);
        try {
            const formData = new FormData();
            formData.append('image', file);

            const response = await HttpClient.fileUplode(
                'upload',
                'POST',
                formData
            );

            if (response && response.status) {
                setFormData(prev => ({
                    ...prev,
                    logoUrl: response.data.url,
                }));
                dispatch(add_logo_url(response.data.url));
                localStorage.setItem('logoUrl', response.data.url);
                toast.success("Logo uploaded successfully");

                // Reset the file input after successful upload
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } else {
                toast.error(response?.message || "Failed to upload logo");
                dispatch(add_logo_url(""));
                // Also reset on failure to allow retry
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        } catch (error) {
            console.error("Error uploading logo:", error);
            toast.error("Error uploading logo");
            dispatch(add_logo_url(""));
            // Reset on error too
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } finally {
            setImageUploadLoader(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation
        if (!formData.clientName) {
            toast.error("Please enter client name");
            return;
        }
        if (!formData.dateIssue) {
            toast.error("Please select issue date");
            return;
        }
        if (!formData.dateDue) {
            toast.error("Please select due date");
            return;
        }
        if (formData.taskList.some(task => !task.taskDescription)) {
            toast.error("Please fill all task descriptions");
            return;
        }
        console.log('formData: ', formData);
        setInvoiceLoader(true);

        try {
            const response = await HttpClient.requestData(
                'createnewinvoice', // Your API endpoint for invoice creation
                'POST',
                formData
            );
            console.log('res: ', response);



            if (response && response.status) {
                setFormData({ // reset the form ...
                    // logoUrl: "",
                    dateIssue: "",
                    clientName: "",
                    taskList: [{ taskDescription: "", rate: 0 }], // Initialize with one empty task
                    total: 0,
                });
                setInvoiceRes(response.data);
                toast.success(response?.message || "Invoice created successfully!");

                // Also reset the file input
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } else {
                toast.error(response?.message || "Failed to create invoice");
            }
        } catch (error) {
            console.error("Error creating invoice:", error);
            toast.error("Error creating invoice");
        } finally {
            setInvoiceLoader(false);
        }
    };


    const [time, setTime] = useState("day");
    const getTime = (val) => {
        setTime(val)
    };

    console.log("subTotal: ", subTotal);

    return (
        <>
            {
                invoiceLoader && (<Loader />)
            }
            {
                imageUploadeLoader && (<Loader />)
            }
            <div className='invoice_creation_Wrapper '>
                <div className='invoice_creation_head'>Invoice Creation</div>

                <div className='invoice_form_div_wrapper d-none'>

                    <div className='invoice_left'>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            columnGap: '10px',
                            color: '#fff',
                            marginBottom: '20px'
                        }}>
                            <h4 style={{
                                marginBottom: '0px '
                            }}>Add logo</h4>
                            <div className='upload_file_wrapper8895856'>
                                <input
                                    type='file'
                                    onChange={handleLogoUpload}
                                    accept='image/*'
                                    ref={fileInputRef} // Add this ref
                                />
                                <div className='additon_wrapper'>
                                    <img
                                        alt='...'
                                        src={add} style={{
                                            width: '20px'
                                        }} />
                                    <h6>Upload File</h6>
                                </div>
                            </div>
                        </div>
                        <h4>Invoice Details</h4>

                        <form className='invoice_left_form_wrapper' onSubmit={handleSubmit}>
                            <div className='invoice_input_div_wrapper' style={{
                                display: "none",
                            }}>
                                <label>ID Invoice </label>
                                <input placeholder='# 2304-ZAK' type='text' />
                                <i class="fa-solid fa-pen-to-square"></i>
                            </div>

                            <div className='invoice_input_div_wrapper2'>
                                <label> Date Issue </label>
                                <input
                                    type='date'
                                    name="dateIssue"
                                    value={formData.dateIssue}
                                    onChange={handleInputChange}
                                />

                            </div>

                            <div className='invoice_input_div_wrapper2'>
                                <label> Date Due </label>
                                <input
                                    type='date'
                                    name="dateDue"
                                    value={formData.dateDue}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <h4 style={{
                                marginTop: '30px'
                            }}>Bil Payment</h4>

                            <div className='invoice_input_div_wrapper'>
                                <label>Client Name</label>
                                {/* <select style={{
                                    background: 'white',
                                    border: 'none',
                                }}>
                                    <option>John Doe</option>
                                    <option>Mark JSON</option>
                                    <option>Louis Griffen</option>

                                </select> */}
                                <input
                                    type="text"
                                    name="clientName"
                                    value={formData.clientName}
                                    onChange={handleInputChange}
                                    style={{
                                        background: 'white',
                                        border: 'none',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        width: '100%'
                                    }}
                                />

                            </div>

                            <h4 style={{
                                marginTop: '30px',
                                display: 'block',
                                width: '100%'
                            }}>
                                List Task
                                <button
                                    type="button"
                                    onClick={addNewTask}
                                    style={{
                                        float: 'right',
                                        background: '#FFDD00',
                                        border: 'none',
                                        borderRadius: '5px',
                                        padding: '5px 10px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Add Task
                                </button>
                            </h4>
                            {formData.taskList.map((task, index) => (
                                <div key={index} className='task_list_wrapper' style={{ display: 'block' }}>
                                    <div className='task_wrapper'>
                                        <label>Task Description</label>
                                        <input
                                            value={task.taskDescription}
                                            onChange={(e) => handleTaskChange(index, 'taskDescription', e.target.value)}
                                        />
                                    </div>

                                    {/* <div className='hours_wrapper'>
                                        <label>Hours</label>
                                        <input
                                            type="number"
                                            value={task.hours}
                                            onChange={(e) => handleTaskChange(index, 'hours', parseInt(e.target.value) || 0)}
                                        />
                                    </div> */}

                                    <div className='hours_wrapper'>
                                        <label>Rate</label>
                                        <input
                                            type="number"
                                            value={task.rate}
                                            onChange={(e) => handleTaskChange(index, 'rate', parseInt(e.target.value) || 0)}
                                        />
                                    </div>
                                    <i
                                        className="fa-solid fa-trash"
                                        onClick={() => removeTask(index)}
                                        style={{ cursor: 'pointer' }}
                                    ></i>
                                </div>
                            ))}

                            <div className='invoice_input_div_wrapper2'>
                                <label>Total Rate</label>
                                <input
                                    type='number'
                                    name="rate"
                                    value={formData.total}
                                    // onChange={handleInputChange}
                                    readOnly={true}
                                />
                            </div>
                            <button
                                type="submit"
                                style={{
                                    marginTop: '20px',
                                    padding: '10px 20px',
                                    background: '#FFDD00',
                                    color: '#0c2637',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    width: '100%'
                                }}
                            >
                                Create Invoice
                            </button>
                        </form>
                    </div>

                    <div className='invoice_right'>
                        <img src={formData?.logoUrl ? formData?.logoUrl : invoiceRes ? invoiceRes?.logoUrl : ''} alt='No Images' />
                        <p>Invoice</p>
                        {/* <h6>ID #2304-ZAK</h6> */}

                        <h5>Bill from</h5>
                        <h2>{formData?.clientName ? formData?.clientName : invoiceRes ? invoiceRes?.clientName : 'No User Name'}</h2>
                        <div className='invoice_address' style={{
                            display: "none"
                        }}>
                            <h3>JI. Pandaan Sejahtera, Pasuruan,
                                Jawa Timur 671256
                            </h3>
                        </div>
                        <div className='item_task_details'>
                            {/* <h1>Item Task</h1>
                            <h1>Logo Design</h1>
                            <h1>Re-design Website</h1>
                            <h1>Pitch Deck 3D</h1> */}
                            {
                                formData?.taskList?.length > 0 && !invoiceRes ? formData?.taskList?.map((task, i) => (
                                    <h1 key={i}>{
                                        task.taskDescription || '-'
                                    }</h1>
                                )) : (<h1>No Task List Present ...</h1>)
                            }
                            {
                                invoiceRes && formData?.clientName?.length === 0 && invoiceRes?.taskList?.length && invoiceRes?.taskList?.map((task, i) => (
                                    <h1 key={i}>{
                                        task.taskDescription || '-'
                                    }</h1>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <div className='invoice_form_div_wrapper'>
                    <div className='invoice_left'>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            columnGap: '10px',
                            color: '#fff',
                            marginBottom: '20px',
                            marginLeft: '15px',
                        }}>
                            <h4 style={{
                                marginBottom: '0px '
                            }}>Add logo</h4>
                            <div className='upload_file_wrapper8895856'>
                                <input
                                    type='file'
                                    onChange={handleLogoUpload}
                                    accept='image/*'
                                    ref={fileInputRef} // Add this ref
                                />
                                <div className='additon_wrapper'>
                                    <img
                                        alt='...'
                                        src={add} style={{
                                            width: '20px'
                                        }} />
                                    <h6>Upload File</h6>
                                </div>
                            </div>
                        </div>
                        <InvoiceForm2 getTime={getTime} value={time} />
                    </div>
                    <div className='invoice_right'>
                        <img
                            style={{ marginRight: '30px' }}
                            src={formData?.logoUrl ? formData?.logoUrl : invoiceRes ? invoiceRes?.logoUrl : ''}
                            alt='No Images' />
                        <p>Invoice</p>
                        {/* <h6>ID #2304-ZAK</h6> */}

                        {
                            customerName && (
                                <>
                                    <h5>Bill from</h5>
                                    <h2>{customerName}</h2>
                                </>
                            )
                        }
                        <div className='invoice_address' style={{
                            display: "none"
                        }}>
                            <h3>JI. Pandaan Sejahtera, Pasuruan,
                                Jawa Timur 671256
                            </h3>
                        </div>
                        <div className='item_task_details'>
                            {/* <h1>Item Task</h1>
                            <h1>Logo Design</h1>
                            <h1>Re-design Website</h1>
                            <h1>Pitch Deck 3D</h1> */}
                            {
                                customerRFCID && (
                                    <h1>Customer RFCID: {customerRFCID}</h1>
                                )
                            }
                            {
                                state && (
                                    <h1>State: {state}</h1>
                                )
                            }
                            {
                                city && (
                                    <h1>City: {city}</h1>
                                )
                            }
                            {
                                zip && (
                                    <h1>Zip: {zip}</h1>
                                )
                            }
                            {
                                emailRecipents && (
                                    <h1>Email Recipents: {emailRecipents}</h1>
                                )
                            }
                            {
                                invoiceDate && (
                                    <h1>Invoice Date: {invoiceDate}</h1>
                                )
                            }
                            {
                                invoice && (
                                    <h1>Invoice: {invoice}</h1>
                                )
                            }
                            {
                                Oredr && (
                                    <h1>Order Id: {invoice}</h1>
                                )
                            }
                            {
                                reference && (
                                    <h1>Reference Id: {reference}</h1>
                                )
                            }
                            {
                                purchaseOrder && (
                                    <h1>Purchase Order Id: {purchaseOrder}</h1>
                                )
                            }
                            {
                                invoiceDetailsType && (
                                    <h1>InvoiceDetails Type: {invoiceDetailsType}</h1>
                                )
                            }
                            {
                                salesTaxPercentage && (
                                    <h1>Sales Tax Percentage: {salesTaxPercentage}</h1>
                                )
                            }
                            {
                                salesTaxAmount && (
                                    <h1>Sales Tax Amount: {salesTaxAmount}</h1>
                                )
                            }
                            {
                                other && (
                                    <h1>Other: {other}</h1>
                                )
                            }
                            {
                                subTotal && (
                                    <h1>Sub-Total: {subTotal}</h1>
                                )
                            }
                            {
                                total && (
                                    <h1>Total: {total}</h1>
                                )
                            }
                            {/* {
                                formData?.taskList?.length > 0 && !invoiceRes ? formData?.taskList?.map((task, i) => (
                                    <h1 key={i}>{
                                        task.taskDescription || '-'
                                    }</h1>
                                )) : (<h1>No Task List Present ...</h1>)
                            }
                            {
                                invoiceRes && formData?.clientName?.length === 0 && invoiceRes?.taskList?.length && invoiceRes?.taskList?.map((task, i) => (
                                    <h1 key={i}>{
                                        task.taskDescription || '-'
                                    }</h1>
                                ))
                            } */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InvoiceCreation;
